var portfolioTransactionDelete = {
	title: "Elimina transazione",
	alertHeading: "Sei sicuro di voler eliminare questa transazione?",
	alertBody: "Se sì, fare clic su Ok. Si prega di notare che le transazioni eliminati non possono essere ripristinate",
	confirmBtn: "Ok",
	cancelBtn: "Annulla"
};
var it = {
	portfolioTransactionDelete: portfolioTransactionDelete
};

export { it as default, portfolioTransactionDelete };
